// Web Lock name the dedicated softphone popup self-registers under. See CT-821.
export const CCP_SOFTPHONE_WINDOW_NAME = 'thyme-ccp-softphone'
export const CCP_SOFTPHONE_ROUTE_PATH = '/ccp-softphone'

// BroadcastChannel the softphone popup uses to tell main tabs its session
// (thymebox's own Auth0 session, or the Amazon Connect Streams session)
// has expired, instead of redirecting itself — which would kill a live
// call. One-directional status ping, not leader election, so it's a good
// fit for BroadcastChannel. See CT-821.
export const CCP_SOFTPHONE_SESSION_CHANNEL_NAME = 'thyme-ccp-softphone-session'
export const CCP_SOFTPHONE_SESSION_EXPIRED_MESSAGE = 'session-expired'

type AWSAttribute = { name: string; value: string }

/**
 * These attributes are a part of our setup for Amazon Connect flows, setup by USAN.
 * They are available, but not intended to be used on the contact object in the CCP.
 * @deprecated Do not use these attributes directly — they are internal to the IVR flow.
 */
type AWSContactFlowAttributes = {
  ANI?: AWSAttribute
  AgentID?: AWSAttribute
  AgentID_0?: AWSAttribute
  AgentID_1?: AWSAttribute
  AgentID_2?: AWSAttribute
  Application?: AWSAttribute
  CMEnvironment?: AWSAttribute
  CallbackRolloverQueue?: AWSAttribute
  CallbackRolloverQueueID?: AWSAttribute
  CallbackTODPlan?: AWSAttribute
  Callbacks?: AWSAttribute
  CallerEntityID_0?: AWSAttribute
  CallerEntityID_1?: AWSAttribute
  CallerEntityID_2?: AWSAttribute
  ContactLens?: AWSAttribute
  ContactLensRedaction?: AWSAttribute
  CurrentDate?: AWSAttribute
  CurrentDay?: AWSAttribute
  CurrentHour?: AWSAttribute
  CustStatus_0?: AWSAttribute
  CustStatus_1?: AWSAttribute
  CustStatus_2?: AWSAttribute
  DNIS?: AWSAttribute
  DOB_0?: AWSAttribute
  DOB_1?: AWSAttribute
  DOB_2?: AWSAttribute
  DOBEntryMenuPrompt?: AWSAttribute
  DOBEntryMenuPromptEnglish?: AWSAttribute
  DOBEntryMenuPromptSpanish?: AWSAttribute
  DOBRetry?: AWSAttribute
  Dnis_TOD?: AWSAttribute
  EnteredDOB?: AWSAttribute
  ExtendedHoursQueue?: AWSAttribute
  FinalTransferReportName?: AWSAttribute
  FlowID?: AWSAttribute
  FlowName?: AWSAttribute
  Greeting?: AWSAttribute
  HangupReportName?: AWSAttribute
  LangMenu?: AWSAttribute
  MemberID_0?: AWSAttribute
  MemberID_1?: AWSAttribute
  MemberID_2?: AWSAttribute
  Mode?: AWSAttribute
  POD_0?: AWSAttribute
  POD_1?: AWSAttribute
  POD_2?: AWSAttribute
  PlanName?: AWSAttribute
  PreTransferMessage?: AWSAttribute
  PromptName?: AWSAttribute
  PromptVerbiage?: AWSAttribute
  QueueDestination?: AWSAttribute
  QueueID?: AWSAttribute
  RCLanguageEnabled?: AWSAttribute
  RCPodEnabled?: AWSAttribute
  RCStateEnabled?: AWSAttribute
  RCTierEnabled?: AWSAttribute
  ReEntry?: AWSAttribute
  RecentCallMenuPrompt?: AWSAttribute
  Record?: AWSAttribute
  RequestID?: AWSAttribute
  Retry?: AWSAttribute
  ReturningCall?: AWSAttribute
  'STEP001-1000 Contact Center Start'?: AWSAttribute
  'STEP002-1000 DNIS Table Read'?: AWSAttribute
  'STEP003-1000 Greeting Msg'?: AWSAttribute
  'STEP004-2000 Language Menu'?: AWSAttribute
  'STEP005-3000 ANI Lookup'?: AWSAttribute
  'STEP006-3000 TOD Table Read'?: AWSAttribute
  'STEP007-TOD Table Lookup No Match'?: AWSAttribute
  'STEP008-3250 DOB Entry Menu'?: AWSAttribute
  'STEP009-4000 Recent Call Menu'?: AWSAttribute
  'STEP010-7000 Intent Table Read'?: AWSAttribute
  'STEP011-7000 QueueSettings Table Read'?: AWSAttribute
  'STEP012-7000 PreQueue Msg'?: AWSAttribute
  State_0?: AWSAttribute
  State_1?: AWSAttribute
  State_2?: AWSAttribute
  TODMatch?: AWSAttribute
  TestLoggingFlag?: AWSAttribute
  Tier_0?: AWSAttribute
  Tier_1?: AWSAttribute
  Tier_2?: AWSAttribute
  TransferReportName?: AWSAttribute
  VMDistro?: AWSAttribute
  VMGreeting?: AWSAttribute
  VMMode?: AWSAttribute
  WhisperMessage?: AWSAttribute
  ZIP_0?: AWSAttribute
  ZIP_1?: AWSAttribute
  ZIP_2?: AWSAttribute
  ZipEnabled?: AWSAttribute
  ani_match_authenticated?: AWSAttribute
  count?: AWSAttribute
  currentStep?: AWSAttribute
  getDateTimeResult?: AWSAttribute
  getResourceIDResult?: AWSAttribute
  queryDnisTableResult?: AWSAttribute
  queryIntentTableResult?: AWSAttribute
  queryMessageTableResult?: AWSAttribute
  queryQueueSettingsTableResult?: AWSAttribute
  queryTODTableResult?: AWSAttribute
  verifMode?: AWSAttribute
}

/**
 * These attributes are custom attributes we have set up on the contact object in the CCP, which are populated by our CCP flows. They are intended to be used in the CCP for call control and UI purposes.
 */
type AWSContactCustomAttributes = {
  CallerEntityID?: AWSAttribute
  MemberID?: AWSAttribute
  CustStatus?: AWSAttribute
  DOB?: AWSAttribute
  Intent?: AWSAttribute
  Language?: AWSAttribute
  POD?: AWSAttribute
  QueueName?: AWSAttribute
  State?: AWSAttribute
  Tier?: AWSAttribute
  ZIP?: AWSAttribute
}

export type AWSContactAttributes = AWSContactFlowAttributes &
  AWSContactCustomAttributes
